
import generateHeader from '~/helpers/header'
import LoleVideoPicture from '~/components/picture/lole-video-picture'
import LoleStaticPageHeader from '~/components/static-page/lole-static-page-header'
import LoleStaticPageSectionTitle from '~/components/static-page/lole-static-page-section-title'
import LoleStaticPageInfoCard from '~/components/static-page/lole-static-page-info-card'
import LoleStaticPageLeadershipCard from '~/components/static-page/lole-static-page-leadership-card'
import LoleStaticPageProfileCard from '~/components/static-page/lole-static-page-profile-card'
import LoleStaticPageCtaBanner from '~/components/static-page/lole-static-page-cta-banner'
import LoleStaticPageImageCollage from '~/components/static-page/lole-static-page-image-collage'
import LoleStaticPageH1 from '~/components/static-page/lole-static-page-h1'
import LoleStaticPageH2 from '~/components/static-page/lole-static-page-h2'
import LoleStaticPageText from '~/components/static-page/lole-static-page-text'
import LoleStaticPageColumns from '~/components/static-page/lole-static-page-columns'
import LoleStaticPageTitleParagraph from '~/components/static-page/lole-static-page-title-paragraph'
import LoleStaticPageHeroVideo from '~/components/static-page/lole-static-page-hero-video'

export default {
  name: 'LoleCareers',
  components: {
    LoleVideoPicture,
    LoleStaticPageHeader,
    LoleStaticPageSectionTitle,
    LoleStaticPageInfoCard,
    LoleStaticPageLeadershipCard,
    LoleStaticPageProfileCard,
    LoleStaticPageCtaBanner,
    LoleStaticPageImageCollage,
    LoleStaticPageH1,
    LoleStaticPageH2,
    LoleStaticPageText,
    LoleStaticPageColumns,
    LoleStaticPageTitleParagraph,
    LoleStaticPageHeroVideo,
  },
  async asyncData({ error, app: { $storyblok, $sentryException } }) {
    try {
      const { story } = await $storyblok.getStory(`/static_pages/careers`)
      return { wording: story.content }
    } catch (e) {
      $sentryException(e, {
        source: 'storyblok',
        level: 'warning',
        extra: 'Call storyblok careers failed',
      })
      error({
        statusCode: 500,
        message: 'Call storyblok careers failed',
      })
    }
  },
  data: () => ({
    wording: null,
  }),

  head() {
    if (!this.wording.seo) return
    this.wording.seo.og_image = this.wording.seo.og_image
      ? this.wording.seo.og_image
      : this.$config.DEFAULT_OG_IMAGE
    return generateHeader({
      ...this.wording.seo,
      path: this.$route.path,
    })
  },
}
